// extracted by mini-css-extract-plugin
module.exports = {"editButton":"Body_editButton__1zkb1"};